import { createTypedEnum } from '@reckon-web/formschema-enums';

export const WorkViewEnum = createTypedEnum({
  TaskList: 'TaskList',
  TaskBoard: 'TaskBoard',
  JobList: 'JobList',
  JobBoard: 'JobBoard',
  JobTaskList: 'JobTaskList',
  JobTaskBoard: 'JobTaskBoard',
} as const);
export type WorkViewValueType = (typeof WorkViewEnum.values)[number];
export type WorkViewLabelType = (typeof WorkViewEnum.labels)[number];
